// PDF.js worker の URL を返す。Webpack 5 は `new URL(spec, import.meta.url)` を
// asset module として解析し、バンドル成果物にハッシュ付き URL を割り当てる。
// このファイルは `import.meta` を含むため、ts-jest 環境でロードすると
// 構文エラー（"Cannot use 'import.meta' outside a module"）になる。
// テストでは `jest.mock("@/components/preview_pdf/pdfjs-worker-url", ...)` で
// このモジュールをまるごと差し替える前提とする。
export const getPdfjsWorkerUrl = (): string =>
  new URL("pdfjs-dist/legacy/build/pdf.worker.mjs", import.meta.url).href;
